import { Button, Modal, Paper } from "@mui/material";
import { Trash2 } from "lucide-react";
import React, { useState } from "react";
import { toast } from "sonner";
import axiosInstance from "../Axios";
import useAuth from "../contexts/UserContext.tsx";

export const DeleteUserModal = ({ userDetails }) => {
  const [modal, setModal] = useState(false);
  const handleOpenModal = () => setModal(true);
  const handleCloseModal = () => setModal(false);
  const { user } = useAuth();

  const handleDeleteUser = () => {
    toast.success("User deleted successfully");
    axiosInstance
      .post("deleteDashboardUser", {
        auth_token: user.auth_token,
        user_id: userDetails.user_id,
      })
      .then(() => {
        window.location.reload();
      })
      .catch(() => {
        toast.error("Error while deleting user");
      });
  };

  return (
    <div className="h-full">
      <Button
        variant="contained"
        color="error"
        onClick={() => {
          handleOpenModal();
        }}
        className="bg-[#4CAF50] hover:bg-green-600 text-white font-semibold py-2 px-2 rounded focus:outline-none focus:shadow-outline-green"
      >
        <Trash2 />
      </Button>
      <Modal
        open={modal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Paper
          elevation={3}
          className="w-fit mx-auto mt-[20%] px-4 py-2 max-w-lg text-left"
        >
          <h1 className="pt-2 font-semibold text-xl text-red-500">
            Delete Dashboard User
          </h1>
          <p>Are you sure you want to delete the user?</p>
          <div className="flex gap-4 w-full justify-center items-center pt-10 pb-2">
            <Button onClick={handleCloseModal}>Cancel</Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleDeleteUser}
            >
              Delete
            </Button>
          </div>
        </Paper>
      </Modal>
    </div>
  );
};
